import { API_HOST, API_URL } from '../config/api'

export { API_HOST, API_URL, SETTINGS_API_URL, SAVED_REST_ID_KEY } from '../config/api'

export const getProfessionsList = async () => {
  try {
    const response = await fetch(API_URL + '/settings/professions_list');
      // .then((response) => {
      //   // if (response.status < 400) return response.json();
      //   if (response.status < 400) return response.json();

      //   else return response.text();
      // })
      if(!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`)
      }
      const data = await response.json();
      return data;
  } catch (err) {
    throw new Error(`Failed to get ProfessionsList: ${err.message}`);
  }

    // fetch(API_URL + '/settings/professions_list')
    // .then((response) => {
    //   if (response.status < 400) return response.json();
    //   else return response.text();
    // })
    // .then((content) => {
    //   setProfOpts(content.map(o => ({value: o, label: o})));
    // })
    // .catch((e) => {
    //   console.error(e);
    // });
}

//https://backend.doski.bar/career
// export const createJobApplication = async ({ body }) => {
export const createJobApplication = async (body) => {

  try {
    const response = await fetch(API_HOST + '/career', {
      method: 'POST',
      body,
    })
    if(!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`)
    }

    const rawResponse = await response.text();
    if (!rawResponse) return { status: 'success' };

    try {
      return JSON.parse(rawResponse);
    } catch {
      return { status: 'success', message: rawResponse };
    }
  } catch (err) {
    throw new Error(`Failed to create JobApplication: ${err.message}`);
  }

      // fetch(API_HOST + '/career', {
    //   method: 'POST',
    //   body,
    // })
    // .then((response) => response.json())
    // .then((content) => {
    //   applicationOk(content)
    // })
    // .catch((e) => {
    //   applicationError(e)
    // })
    // .finally(() => {
    //   setApplicationState(prev => ({...prev, pending: false}))
    // })
}
